import type { CurationColumn } from "@/features/data-curation/types";

export const SchemaColumnsTable = ({ columns }: { columns: CurationColumn[] }) => (
  <div className="overflow-x-auto rounded-[3px] border border-zinc-200">
    <table className="min-w-full text-left text-sm">
      <thead className="bg-zinc-50 text-xs text-zinc-500">
        <tr>
          <th scope="col" className="px-4 py-3 font-medium">Label</th>
          <th scope="col" className="px-4 py-3 font-medium">Type</th>
          <th scope="col" className="px-4 py-3 font-medium">Description</th>
          <th scope="col" className="px-4 py-3 font-medium">Required</th>
        </tr>
      </thead>
      <tbody>
        {columns.map((column) => (
          <tr key={column.column_id} className="border-t border-zinc-200">
            <th scope="row" className="px-4 py-4 font-medium text-zinc-900">
              {column.label}
            </th>
            <td className="px-4 py-4 font-mono text-xs text-zinc-600">{column.value_type}</td>
            <td className="max-w-xl px-4 py-4 text-zinc-600">
              <p>{column.description || "No description provided"}</p>
              {column.normalization_rules && (
                <p className="mt-1 text-xs text-zinc-500">
                  Normalize: {column.normalization_rules}
                </p>
              )}
              {(column.examples ?? []).length > 0 && (
                <p className="mt-1 text-xs text-zinc-500">
                  Examples:{" "}
                  {(column.examples ?? []).map((value) => JSON.stringify(value)).join(", ")}
                </p>
              )}
              {(column.options ?? []).length > 0 && (
                <p className="mt-1 text-xs text-zinc-500">
                  Options: {(column.options ?? []).join(" · ")}
                </p>
              )}
            </td>
            <td className="px-4 py-4 text-zinc-600">{column.required ? "Yes" : "No"}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);
